import moment from 'moment';
import config from '~/config';

export const date = (data) => {
    if (!data) {
        return null;
    }
    return moment(data, config.formats.dates.frontend).format(config.formats.dates.api);
};
